import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.title !== null) {
      params.set("title", this.filters.advanced.title);
    }

    if (this.filters.advanced.currentlyWorking.length > 0) {
      this.filters.advanced.currentlyWorking.forEach((element) =>
        params.append("currentlyWorking", element)
      );
    }

    if (this.filters.advanced.iscoCode !== null) {
      params.set("iscoCode", this.filters.advanced.iscoCode);
    }

    if (this.filters.advanced.odysseaSupport !== null) {
      params.set("odysseaSupport", this.filters.advanced.odysseaSupport);
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.workSatisfaction !== null) {
      params.set("workSatisfaction", this.filters.advanced.workSatisfaction);
    }

    if (this.filters.advanced.trainingType.length > 0) {
      this.filters.advanced.trainingType.forEach((element) =>
        params.append("trainingType", element)
      );
    }

    if (this.filters.advanced.route.length > 0) {
      this.filters.advanced.route.forEach((element) =>
        params.append("route", element)
      );
    }

    if (this.filters.advanced.suitableJobs.length > 0) {
      this.filters.advanced.suitableJobs.forEach((element) =>
        params.append("suitableJobs", element.id)
      );
    }

    if (this.filters.advanced.projects.length > 0) {
      this.filters.advanced.projects.forEach((element) =>
        params.append("projects", element)
      );
    }

    if (this.filters.advanced.employmentStatus.length > 0) {
      this.filters.advanced.employmentStatus.forEach((element) =>
        params.append("employmentStatus", element)
      );
    }

    if (this.filters.advanced.responsible.length > 0) {
      this.filters.advanced.responsible.forEach((element) =>
        params.append("responsible", element)
      );
    }

    if (
      this.filters.advanced.date != null &&
      this.filters.advanced.date.length > 0
    ) {
      const startDate = this.filters.advanced.date[0];
      const endDate = this.filters.advanced.date.at(-1);
      params.set("startDate", formatDateToIsoString(new Date(startDate)));
      params.set("endDate", formatDateToIsoString(new Date(endDate)));
    }

    if (this.filters.advanced.completedCourses.length > 0) {
      this.filters.advanced.completedCourses.forEach((element) =>
        params.append("completedCourses", element)
      );
    }

    return params;
  },
};
